import type { CSSProperties } from 'react';
import type { CartSettingsConfig } from '@/lib/cart-settings';
import type { AccountSettings } from '@/lib/site-settings';

export interface AnnouncementBarMessage {
	text: string;
	link?: string | null;
}

export interface AnnouncementBar {
	enabled?: boolean | null;
	messages?: AnnouncementBarMessage[];
	backgroundColor?: string | null;
	textColor?: string | null;
}

export interface MobileLearnLink {
	label: string;
	url: string;
}

export interface MobileNeedHelpLink {
	icon: string;
	label: string;
	url: string;
}

export interface NavItem {
	label: string;
	url?: string | null;
	type?: string;
	textColor?: string | null;
	children?: NavItem[];
	featuredImages?: Array<{
		url: string;
		alt: string;
		label?: string;
		linkUrl?: string;
	}>;
}

export interface PopularProduct {
	id: string;
	handle: string;
	title: string;
	availableForSale: boolean;
	featuredImage: {
		url: string;
		altText: string | null;
		width: number;
		height: number;
	} | null;
	priceRange: {
		minVariantPrice: {
			amount: string;
			currencyCode: string;
		};
	};
	compareAtPriceRange: {
		minVariantPrice: {
			amount: string;
			currencyCode: string;
		};
	} | null;
	rating?: number | null;
	reviewCount?: number | null;
}

export interface TrendingSearch {
	term: string;
	url?: string;
}

export interface SiteHeaderProps {
	announcementBar?: AnnouncementBar;
	logoText?: string | null;
	logoUrl?: string | null;
	logoWidth?: number | null;
	logoHeight?: number | null;
	mobileNeedHelpHeading?: string;
	mobileNeedHelpLinks?: MobileNeedHelpLink[];
	mobileShowAccountLink?: boolean;
	mobileLearnHeading?: string;
	mobileLearnLinks?: MobileLearnLink[];
	navigation?: NavItem[];
	cartSettings: CartSettingsConfig;
	accountSettings?: AccountSettings;
	enableCustomerAccounts?: boolean;
	enableReviews?: boolean;
	popularProducts?: PopularProduct[];
	popularProductHandles?: string[];
	popularProductsHeading?: string;
	trendingSearches?: TrendingSearch[];
}

export function getAccountDrawerErrorMessage(errorCode: string | null) {
	if (!errorCode) return null;

	switch (errorCode) {
		case 'auth_failed':
			return "We couldn't sign you in. Please try again.";
		case 'no_code':
		case 'state_mismatch':
		case 'token_exchange':
			return "We couldn't finish signing you in. Please try again.";
		default:
			return "We couldn't finish signing you in. Please try again.";
	}
}

export function getAnnouncementBarStyle(
	announcementBar?: AnnouncementBar,
): CSSProperties | undefined {
	return {
		backgroundColor: announcementBar?.backgroundColor || '#1a1a1a',
		color: announcementBar?.textColor || '#ffffff',
	};
}
